import { render, staticRenderFns } from "./groupFitnessDashboardWarnings.vue?vue&type=template&id=1d2a48b0&scoped=true"
import script from "./groupFitnessDashboardWarnings.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardWarnings.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardWarnings.vue?vue&type=style&index=0&id=1d2a48b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2a48b0",
  null
  
)

export default component.exports